import { useState } from 'react';
import '../styles/login.css';
import Translate from '../shared/Translate';
import { errorLogEnabled } from '../shared/Utils';

const Login = ({ container, onLogin, ocTenant }) => {
  const [username, setUsername] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [loginError, setLoginError] = useState('');
  
  const handleLogin = () => {
    if (username && apiKey) {
      onLogin()
      container.ask({
        _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$Login',
        userName: username,
        apiKey: apiKey,
      }).then((result) => {
        if (!result?.success) {
          setLoginError('login.error.invalidCredentials');
        }
        else {
          setLoginError('');
        }
      }).catch((error) => {
        errorLogEnabled && console.error(error);
      });
    } else {
      setLoginError('login.error.emptyFields');
    }
  };

  const setLanguage = (language) => {
    Translate.setLanguage(language);
    container.tell({
      _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$UpdateLanguage',
      language: language
    })
  }
  
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="lang-switch blue">
            <button 
              className={Translate.language === 'en' ? 'active': ''}
              onClick={() => setLanguage('en')}
            >
              {Translate.get('language.en')}
            </button> |
            <button 
              className={Translate.language === 'cs' ? 'active': ''}
              onClick={() => setLanguage('cs')}
            >
              {Translate.get('language.cs')}
            </button>
          </div>
          <h2 className="login-title">{Translate.get('login.connectToOptimCall')}</h2>
        </div>
        <div className="login-form">
          <div className="login-info">
            <label className="login-info-label">{Translate.get('login.info')}</label>
            <label className="login-tenant">{ocTenant}</label>
          </div>
          
          <div className="login-input">
            <label className="login-label">{Translate.get('login.username')}</label>
            <input 
              type="text" 
              className="login-field"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin();
                }
              }}
            />
          </div>
          
          <div className="login-input">
            <label className="login-label">{Translate.get('login.apiKey')}</label>
            <input 
              type="password" 
              className="login-field"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin();
                }
              }}
            />
          </div>

          <div className={'login-error'}>{loginError && Translate.get(loginError)}</div>

          <button 
            className="login-button"
            onClick={handleLogin}
          >
            {Translate.get('login.connect.button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;